import { Expose, Transform } from '@nts/std/serialization';
import { OCCModel } from './occ-model';
import { DateTimeOffset } from '@nts/std/types';
import type { AuditModelInterface, DeactivableModelInterface, IdentityInterface, OCCModelInterface } from '@nts/std/interfaces';
import { StringDecorator } from './decorators/string.decorator';
import { DateDecorator } from './decorators/date.decorator';
import { BoolDecorator } from './decorators/bool.decorator';


export class OCCAuditDeactivableModel<TIdentity extends IdentityInterface>
  extends OCCModel<TIdentity> implements AuditModelInterface, DeactivableModelInterface<TIdentity>, OCCModelInterface<TIdentity> {

  static override PROPERTY_LIST: string[] = [
    ...OCCModel.PROPERTY_LIST,
    'updateUser',
    'updateDate',
    'creationUser',
    'creationDate',
    'isActive'
  ];

  constructor() {
    super();
    this.isActive = true;
  }

  private _updateUser: string;

  @Expose()
  @StringDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_UpdateUser',
  })
  get updateUser(): string {
    return this.getValue<string>(() => this._updateUser, 'updateUser');
  }
  set updateUser(value: string) {
    this.setValue<string>(() => { this._updateUser = value; }, value, 'updateUser');
  }

  private _updateDate: Date;

  @Expose()
  @DateDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_UpdateDate',
    isDateTimeOffset: true
  })
  @Transform(DateTimeOffset.transform)
  get updateDate(): Date {
    return this.getValue<Date>(() => this._updateDate, 'updateDate');
  }
  set updateDate(value: Date) {
    this.setValue<Date>(() => { this._updateDate = value; }, value, 'updateDate');
  }

  private _creationUser: string;

  @Expose()
  @StringDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_CreationUser',
  })
  get creationUser(): string {
    return this.getValue<string>(() => this._creationUser, 'creationUser');
  }
  set creationUser(value: string) {
    this.setValue<string>(() => { this._creationUser = value; }, value, 'creationUser');
  }

  private _creationDate: Date;

  @Expose()
  @DateDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_CreationDate',
    isDateTimeOffset: true
  })
  @Transform(DateTimeOffset.transform)
  get creationDate(): Date {
    return this.getValue<Date>(() => this._creationDate, 'creationDate');
  }
  set creationDate(value: Date) {
    this.setValue<Date>(() => { this._creationDate = value; }, value, 'creationDate');
  }

  private _isActive: boolean;

  @Expose()
  @BoolDecorator({
    displayNameKey: 'std_OCCAuditDeactivableModel_IsActive',
  })
  get isActive(): boolean {
    return this.getValue<boolean>(() => this._isActive, 'isActive');
  }
  set isActive(value: boolean) {
    this.setValue<boolean>(() => { this._isActive = value; }, value, 'isActive');
  }
}
